import { render, staticRenderFns } from "./vmc4.vue?vue&type=template&id=00e704f4"
import script from "./vmc4.vue?vue&type=script&lang=js"
export * from "./vmc4.vue?vue&type=script&lang=js"
import style0 from "./vmc4.vue?vue&type=style&index=0&id=00e704f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports